export const urlRegex =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
export const youtubeVideoUrlRegex =
  /^(https?:\/\/)?(www\.|m\.)?(youtube.com|youtu\.be)\/.+v=(?<videoId>.+?)(?=&|$)/;
export const driveVideoUrlRegex =
  /^(https?\:\/\/)?(drive\.google\.com)\/.+\/d\/(?<videoId>.+)\/.*$/;

export const helpUrl =
  'https://docs.google.com/document/d/15NtJn3X_sc1Z0mg7szMLu3zZqApaFkU7Icl_2yvm4xE';
export const diamondHelpUrl =
  'https://docs.google.com/document/d/12Kcz2JxBCA_odESin-SHKWwe35V7_klfEOqMBfLqk3s';

export const showcaseUrl = 'https://project-showcase.ubilabs.dev';
